import { useFormik } from "formik";
import TextArea from "../sharedComponents/textarea/textArea";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../tasks/formikValidation";
import Lang from "../../userPreferences/staticWords";
import Button from "../sharedComponents/buttons/button";
import { useDispatch } from "react-redux";
import * as actionTypes from "../../API/store/actions/actionTypes";
import TextInput from "../sharedComponents/inputs/textInput";
import { editForumData } from "../../API/store/actions/discussion/discussion";

const EditDiscussionForm = ({
  userToken,
  setVisible,
  forumData,
  setProcAdded,
  procAdded,
}) => {
  const dispatch = useDispatch();

  const submit = async (values) => {
    let formData = new FormData();
    const newData = {
      Id: values.Id,
      Title: values.Title,
      Description: values.Description,
    };

    for (let [key, value] of Object.entries(newData)) {
      formData.append(key, value);
    }

    let res = await editForumData(formData, userToken);
    if (res.status <= 206) {
      dispatch({ type: actionTypes.RELOAD });
      setProcAdded(!procAdded);
      setVisible(false);
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      forumData.data,
      validationSchema,
      "editForum",
      submit
    )
  );
  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
    resetForm,
    setFieldTouched,
  } = formik;

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex flex-column align-items-center">
        <TextInput
          errorMessage={formikValidation(touched, errors, "Title")}
          name={"Title"}
          onChange={handleChange}
          type={"text"}
          containerStyle={"col-11 my-2"}
          value={values.Title}
          placeholder={Lang.title + "*"}
        />
        <div className="d-flex flex-column col-12 mt-2">
          <label className="col-11 container">{Lang.Description + "*"}</label>
          <TextArea
            errorMessage={formikValidation(touched, errors, "Description")}
            rows={6}
            name={"Description"}
            onChange={handleChange}
            containerStyle={"col-11 my-2 align-self-center"}
            value={values.Description}
            placeholder={Lang.Description + "*"}
          />
        </div>

        <div className="d-flex justify-content-around align-items-center my-3 col-10">
          <Button
            containerStyle={"col-4"}
            type={"submit"}
            content={Lang.save}
            buttonStyleType={"solid"}
          />
        </div>
      </div>
    </form>
  );
};

export default EditDiscussionForm;
